module.exports = __webpack_public_path__ + "img/electric-mining-drill-W-drill-received-shadow.cd5d4b04.png";